import moment from "moment";
import {
  FETCH_PROPERTIES_SUCCESS,
  FETCH_PROPERTY_SUCCESS,
  FETCH_PROPERTY_REVIEW_SUCCESS,
} from "./types";
import { getTenantDomain } from "../helper";
import { appendSearchParams } from "../helper/guests";

export const fetchPropertiesSuccess = (properties) => ({
  type: FETCH_PROPERTIES_SUCCESS,
  payload: properties,
});

// Divisible by the 1, 2 and 3 columns of the list, so a full page fills its last row.
export const PROPERTIES_PER_PAGE = 12;

export const fetchProperties = (page, options, tenant) => {
  const perPage = PROPERTIES_PER_PAGE;
  const base_url = `${getTenantDomain(tenant)}/api/iframe/properties`;

  let url;
  if (options) {
    const { location, startDate, endDate, persons, type } = options;
    const params = new URLSearchParams({
      page,
      perPage,
      location: location ?? "",
      startDate: startDate ? moment(startDate).format("YYYY-MM-DD") : "",
      endDate: endDate ? moment(endDate).format("YYYY-MM-DD") : "",
      type: type ?? "",
    });
    // Adults, the number of children and the age of each child.
    appendSearchParams(params, persons);
    url = `${base_url}?${params.toString()}`;
  } else {
    url = `${base_url}?page=${page}&perPage=${perPage}`;
  }
  return (dispatch) => {
    // Make API call to fetch properties
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        dispatch(fetchPropertiesSuccess(data));
      })
      .catch((error) => {
        console.log("Error fetching properties:", error);
      });
  };
};

export const fetchProperty = (id, options, tenant) => {
  const base_url = `${getTenantDomain(tenant)}/api/iframe/get-property/${id}`;

  let url;
  if (options) {
    const { startDate, endDate, persons } = options;
    const today = moment().format("YYYY-MM-DD");
    const tomorrow = moment().add(1, "days").format("YYYY-MM-DD");
    const params = new URLSearchParams({
      startDate: moment(startDate).isValid()
        ? moment(startDate).format("YYYY-MM-DD")
        : today,
      endDate: moment(endDate).isValid()
        ? moment(endDate).format("YYYY-MM-DD")
        : tomorrow,
    });
    appendSearchParams(params, persons);
    url = `${base_url}?${params.toString()}`;
  } else {
    url = base_url;
  }

  return (dispatch) => {
    // Make API call to fetch properties
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        dispatch(FetchPropertySuccess(data));
      })
      .catch((error) => {
        // go back to main page
        // window.location.href = "/"
        console.log("Error fetching property:", error);
      });
  };
};

export const FetchPropertySuccess = (property) => ({
  type: FETCH_PROPERTY_SUCCESS,
  payload: property,
});

export const fetchPropertyReviews = (tenant, id) => {
  const base_url = `${getTenantDomain(
    tenant
  )}/api/iframe/property-reviews/${tenant}/${id}`;

  return (dispatch) => {
    fetch(base_url)
      .then((response) => response.json())
      .then((data) => {
        dispatch(fetchPropertyReviewsSuccess(data));
      })
      .catch((error) => {
        console.log("Error fetching property reviews:", error);
      });
  };
};

export const fetchPropertyReviewsSuccess = (reviews) => ({
  type: FETCH_PROPERTY_REVIEW_SUCCESS,
  payload: reviews,
});
